/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemePaymentDetailsEditor extends Common.GridEditorBase<SchemePaymentDetailsRow> {
        protected getColumnsKey() { return "Scheme.SchemePaymentDetails"; }
        protected getDialogType() { return SchemePaymentDetailsDialog; }
        protected getLocalTextPrefix() { return SchemePaymentDetailsRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);
            var x = 0;
        }

        validateEntity(row: SchemePaymentDetailsRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.ModeId = Q.toId(row.ModeId);

            var sameMode= Q.tryFirst(this.view.getItems(), x => x.ModeId === row.ModeId);
            if (sameMode && this.id(sameMode) !== id) {
                Q.alert('This Mode is already in Receipt!');
                return false;
            }

            //update values in grid

            row.Code = OMS.PaymentModeRow.getLookup().itemById[row.ModeId].Code;
            return true;
        } 

        

    }
}